import {FeaturesEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {TypesOfPlansEnum} from 'presentation/pages/private/health-card/constants';

import healthCardAdornmentCcg from 'presentation/assets/images/healthcard-adornment-ccg.svg';
import healthCardAdornment from 'presentation/assets/images/healthcard-adornment-default.svg';
import healthCardAdornmentIntegrated from 'presentation/assets/images/healthcard-adornment-integrated.svg';
import cardFooterAdvanceGndiSp from 'presentation/assets/images/healthcard-advance-gndisp.svg';
import cardFooterInfinityGndiSp from 'presentation/assets/images/healthcard-infinity-gndisp.svg';
import cardFooterNotredameSaudeGndiSp from 'presentation/assets/images/healthcard-notredame-saude-gndisp.svg';
import cardFooterOurDoctorGndiSp from 'presentation/assets/images/healthcard-our-doctor-gndisp.svg';
import cardFooterOurPlanGndiSp from 'presentation/assets/images/healthcard-our-plan-gndisp.svg';
import cardFooterSmartGndiSp from 'presentation/assets/images/healthcard-smart-gndisp.svg';
import cardFooterOuroNotredame from 'presentation/assets/images/healthcard-ouro-notredame.svg';
import cardFooterPrataNotredame from 'presentation/assets/images/healthcard-prata-notredame.svg';
import cardFooterDiamanteNotredame from 'presentation/assets/images/healthcard-diamante-notredame.svg';
import {NEW_WALLET_PLAN_TYPES, OurDoctorCardConstants} from './constants';
import {GetCardBackgroundImageProps} from './types';

export function getCardBackgroundImage({
	planType,
	isIntegrated,
	cdModeloCarteira,
	cdParceiroLogo,
}: GetCardBackgroundImageProps) {
	const {isCCG, isGndiSaoPaulo, isNotredameSaude} = useHostName();
	const {isEnabled: isNewWalletsEnabled} = useFeatureFlag(FeaturesEnum.PORTAL_NEW_WALLETS_PPO);
	const shouldRenderOurDoctorCard =
		planType === TypesOfPlansEnum.NOSSO_MEDICO &&
		cdModeloCarteira === OurDoctorCardConstants.OUR_DOCTOR_CARD_MODEL &&
		cdParceiroLogo === OurDoctorCardConstants.OUR_DOCTOR_CARD_PARTNER_LOGO;

	if (isCCG) return healthCardAdornmentCcg;

	if (shouldRenderOurDoctorCard) {
		return cardFooterOurDoctorGndiSp;
	}

	if (isGndiSaoPaulo || isNotredameSaude) {
		const planTypeMap: Record<TypesOfPlansEnum, string> = {
			[TypesOfPlansEnum.SMART]: cardFooterSmartGndiSp,
			[TypesOfPlansEnum.NOTREDAME_SAUDE]: cardFooterNotredameSaudeGndiSp,
			[TypesOfPlansEnum.ADVANCE]: cardFooterAdvanceGndiSp,
			[TypesOfPlansEnum.INFINITY]: cardFooterInfinityGndiSp,
			[TypesOfPlansEnum.NOSSO_PLANO]: cardFooterOurPlanGndiSp,
			[TypesOfPlansEnum.NOSSO_MEDICO]: cardFooterOurDoctorGndiSp,
			[TypesOfPlansEnum.OURO]: cardFooterOuroNotredame,
			[TypesOfPlansEnum.PRATA]: cardFooterPrataNotredame,
			[TypesOfPlansEnum.DIAMANTE]: cardFooterDiamanteNotredame,
		};

		const isNewWallet = NEW_WALLET_PLAN_TYPES.includes(planType as TypesOfPlansEnum);

		if (isNewWallet && !isNewWalletsEnabled) {
			return planTypeMap[TypesOfPlansEnum.NOTREDAME_SAUDE];
		}

		return planTypeMap[planType as TypesOfPlansEnum] ?? planTypeMap[TypesOfPlansEnum.SMART];
	}

	return isIntegrated ? healthCardAdornmentIntegrated : healthCardAdornment;
}
